import { Component, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { GetEmplolyeeCodeSettingForViewDto, EmplolyeeCodeSettingDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    selector: 'viewEmplolyeeCodeSettingModal',
    templateUrl: './view-emplolyeeCodeSetting-modal.component.html'
})
export class ViewEmplolyeeCodeSettingModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    item: GetEmplolyeeCodeSettingForViewDto;


    constructor(
        injector: Injector
    ) {
        super(injector);
        this.item = new GetEmplolyeeCodeSettingForViewDto();
        this.item.emplolyeeCodeSetting = new EmplolyeeCodeSettingDto();
    }

    show(item: GetEmplolyeeCodeSettingForViewDto): void {
        this.item = item;
        this.active = true;
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
